function showCustomAlert(message, type = 'error') {
    let overlay = document.getElementById('custom-alert-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'custom-alert-overlay';
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100vw';
        overlay.style.height = '100vh';
        overlay.style.backgroundColor = 'rgba(0,0,0,0.3)';
        overlay.style.zIndex = '9999';
        overlay.style.opacity = '0';
        overlay.style.visibility = 'hidden';
        overlay.style.transition = 'all 0.3s ease';
        document.body.appendChild(overlay);

        overlay.addEventListener('click', function() {
            let alertBox = document.getElementById('custom-alert-box');
            if(alertBox) alertBox.classList.remove('show');
            overlay.style.opacity = '0';
            setTimeout(() => overlay.style.visibility = 'hidden', 300);
        });
    }

    let alertBox = document.getElementById('custom-alert-box');
    if (!alertBox) {
        alertBox = document.createElement('div');
        alertBox.id = 'custom-alert-box';
        alertBox.className = 'custom-alert';
        document.body.appendChild(alertBox);

        alertBox.addEventListener('click', function() {
            alertBox.classList.remove('show');
            overlay.style.opacity = '0';
            setTimeout(() => overlay.style.visibility = 'hidden', 300);
        });
    }
    
    const iconSvg = type === 'success' 
        ? `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#30c1ba" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>`
        : `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff6b6b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>`;
    
    alertBox.innerHTML = `<div class="custom-alert-icon" style="display: flex; align-items: center; justify-content: center; background: ${type === 'success' ? 'rgba(48, 193, 186, 0.1)' : 'rgba(255, 107, 107, 0.1)'}; width: 60px; height: 60px; border-radius: 50%; margin-bottom: 4px;">${iconSvg}</div><div style="font-size: 1.05rem;">${message}</div>`;
    alertBox.classList.add('show');
    
    overlay.style.visibility = 'visible';
    overlay.style.opacity = '1';
    
    if (window.customAlertTimeout) clearTimeout(window.customAlertTimeout);
    
    window.customAlertTimeout = setTimeout(() => {
        alertBox.classList.remove('show');
        overlay.style.opacity = '0';
        setTimeout(() => overlay.style.visibility = 'hidden', 300);
    }, 4000);
}

document.addEventListener('DOMContentLoaded', () => {
    // Mobile Menu Toggle
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const navLinks = document.getElementById('navLinks');
    
    if (mobileMenuBtn && navLinks) {
        mobileMenuBtn.addEventListener('click', () => {
            navLinks.classList.toggle('active');
        });
        
        // Close menu when a link is clicked
        navLinks.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                navLinks.classList.remove('active');
            });
        });
    }

    // Slider functionality
    const slider = document.getElementById('reviewsSlider');
    const prevBtn = document.querySelector('.slider-prev');
    const nextBtn = document.querySelector('.slider-next');

    if (slider && prevBtn && nextBtn) {
        const scrollAmount = 350; // Roughly one card width + gap

        nextBtn.addEventListener('click', () => {
            slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        prevBtn.addEventListener('click', () => {
            slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
    }

    // Product Gallery Slider (Thumbnails)
    const mainImg = document.getElementById('checkout-main-img');
    const thumbBtns = document.querySelectorAll('.thumb-btn');
    
    if (mainImg && thumbBtns.length > 0) {
        thumbBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                // Update main image source
                const thumbImg = btn.querySelector('img');
                mainImg.src = thumbImg.src;
                
                // Update active state
                document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
                thumbImg.classList.add('active');
            });
        });
    }

    // Modal functionality
    const modalTriggers = document.querySelectorAll('.modal-trigger');
    const modals = document.querySelectorAll('.modal');
    const closeBtns = document.querySelectorAll('.close-modal');

    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const modalId = trigger.getAttribute('data-modal');
            const modal = document.getElementById(modalId);
            if (modal) {
                modal.classList.add('active');
                document.body.style.overflow = 'hidden'; // Prevent background scrolling
            }
        });
    });

    closeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const modal = btn.closest('.modal');
            modal.classList.remove('active');
            document.body.style.overflow = '';
        });
    });

    // Close on outside click
    window.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal')) {
            e.target.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const variantRadios = document.querySelectorAll(".variant-radio");
    const priceDisplay = document.querySelector(".current-price");
    
    variantRadios.forEach(radio => {
        radio.addEventListener("change", function() {
            if (this.checked && this.dataset.price) {
                priceDisplay.textContent = this.dataset.price;
            }
        });
    });

    const addToCartForm = document.getElementById('add-to-cart-form');
    if (addToCartForm) {
        addToCartForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const submitBtn = addToCartForm.querySelector('button[type="submit"]');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.style.opacity = '0.8';
            }

            const selectedRadio = document.querySelector('.variant-radio:checked');
            if (selectedRadio && selectedRadio.value) {
                // Shopify Cart Permalink: /cart/{variant_id}:{quantity}?checkout
                // This automatically clears old items, adds the new one, and goes straight to checkout instantly!
                window.location.href = '/cart/' + selectedRadio.value + ':1?checkout';
            } else {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.style.opacity = '1';
                }
                showCustomAlert('Please select a pack before proceeding.');
            }
        });
    }

    // Urgency Logic - Believable & Persistent
    const viewerCountEl = document.getElementById('viewer-count');
    const stockCountEl = document.getElementById('stock-count');

    if (viewerCountEl && stockCountEl) {
        const now = new Date().getTime();
        let urgencyData = JSON.parse(localStorage.getItem('wary_urgency_data') || 'null');

        // Reset if data is older than 2 hours to keep it dynamic but not rapidly changing
        if (!urgencyData || (now - urgencyData.timestamp > 2 * 60 * 60 * 1000)) {
            urgencyData = {
                viewers: Math.floor(Math.random() * (75 - 30 + 1)) + 30, // 30 to 75
                stock: Math.floor(Math.random() * (18 - 6 + 1)) + 6, // 6 to 18
                timestamp: now
            };
            localStorage.setItem('wary_urgency_data', JSON.stringify(urgencyData));
        }

        // Occasionally fluctuate viewers while on page
        setInterval(() => {
            if (Math.random() > 0.6) {
                let change = Math.floor(Math.random() * 3) - 1; // -1, 0, or +1
                urgencyData.viewers += change;
                // keep boundaries
                if (urgencyData.viewers < 25) urgencyData.viewers = 25;
                if (urgencyData.viewers > 85) urgencyData.viewers = 85;
                
                localStorage.setItem('wary_urgency_data', JSON.stringify(urgencyData));
                viewerCountEl.textContent = urgencyData.viewers + ' people';
            }
        }, 12000); // Check every 12 seconds

        viewerCountEl.textContent = urgencyData.viewers + ' people';
        stockCountEl.textContent = urgencyData.stock + ' left';
    }

    // Disable Right Click (Copy Protection)
    document.addEventListener('contextmenu', event => event.preventDefault());

    // Disable Image Dragging
    document.addEventListener('dragstart', event => {
        if (event.target.tagName === 'IMG') {
            event.preventDefault();
        }
    });

    // Contact Form AJAX Submission
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const submitBtn = contactForm.querySelector('button[type="submit"]');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = "SENDING...";
                submitBtn.style.opacity = '0.8';
            }
            
            fetch(contactForm.action, {
                method: 'POST',
                body: new FormData(contactForm)
            })
            .then(() => {
                // Create or show success message without destroying the form structure
                let successMsg = document.getElementById('ajax-success-msg');
                if (!successMsg) {
                    successMsg = document.createElement('div');
                    successMsg.id = 'ajax-success-msg';
                    successMsg.innerHTML = `
                        <div style="text-align: center; padding: 20px 0;">
                            <div style="width: 60px; height: 60px; background: rgba(18, 184, 177, 0.1); color: var(--primary); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;">
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            </div>
                            <h3 style="margin-bottom: 8px;">Message Sent!</h3>
                            <p style="color: var(--text-light); margin-bottom: 24px;">Thank you for contacting us. Our support team will get back to you within 24 hours.</p>
                            <button type="button" class="btn-primary" style="width: 100%;" onclick="closeContactModalAndReset()">Close</button>
                        </div>
                    `;
                    contactForm.parentNode.insertBefore(successMsg, contactForm);
                }
                
                // Hide all form children
                Array.from(contactForm.children).forEach(child => {
                    if (child.tagName !== 'INPUT' || child.type !== 'hidden') {
                        child.style.display = 'none';
                    }
                });
                
                // Show success message
                successMsg.style.display = 'block';
                
                // Define reset function globally if not exists
                if (!window.closeContactModalAndReset) {
                    window.closeContactModalAndReset = function() {
                        // Hide modal
                        const modal = document.getElementById('modal-contact');
                        if (modal) modal.classList.remove('active');
                        document.body.style.overflow = '';
                        
                        // Reset form
                        contactForm.reset();
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.textContent = "SEND MESSAGE";
                            submitBtn.style.opacity = '1';
                        }
                        
                        // Show form children again
                        Array.from(contactForm.children).forEach(child => {
                            if (child.tagName !== 'INPUT' || child.type !== 'hidden') {
                                child.style.display = '';
                            }
                        });
                        
                        // Hide success message
                        const msg = document.getElementById('ajax-success-msg');
                        if (msg) msg.style.display = 'none';
                        
                        // Clean URL if needed
                        if (window.location.search.includes('contact_posted=true')) {
                            window.history.replaceState(null, '', window.location.pathname);
                        }
                    };
                }
                
                // Auto close after 5 seconds
                setTimeout(function() {
                    if (document.getElementById('ajax-success-msg') && document.getElementById('ajax-success-msg').style.display !== 'none') {
                        window.closeContactModalAndReset();
                    }
                }, 5000);
            })
            .catch(err => {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = "SEND MESSAGE";
                    submitBtn.style.opacity = '1';
                }
            });
        });
    }
});


// Prevent right click and drag
document.addEventListener('contextmenu', event => event.preventDefault());
document.addEventListener('dragstart', event => {
    if (event.target.tagName.toLowerCase() === 'img') {
        event.preventDefault();
    }
});

